import { debounce } from '../function/debounce';

function autocomplete(searchForm: HTMLInputElement) {
    let currentFocus: number;

    if (!searchForm) return;

    const searchInput = searchForm.getElementsByTagName('input')[0];
    const searchButton = searchForm.getElementsByTagName('button')[0];

    const getDataFromApi = async (prefix: string) => {
        if (prefix != '') {
            const searchActionUrl: string = searchForm.querySelector('form').getAttribute('action');
            await fetch(`${searchActionUrl}/Suggest?prefix=${prefix}`)
                .then((response) => response.json())
                .then((json) => {
                    const suggestions: string[] = json.hits.map((hit) => hit.query);
                    if (suggestions.length > 0){
                        createList(suggestions, prefix);
                    }
                })
                .catch((error) => {
                    console.log('error', error);
                }
            );
        }
    };


    // <li aria-selected="false" class="autocomplete__option autocomplete__option--odd" id="autocomplete-default__option--1" role="option" tabindex="-1" aria-posinset="2" aria-setsize="3">Central African Republic</li>

    const createList = (items: string[], fieldVal: string) => {
        let divCreate, ulCreate, listElement, i, listButton;

        currentFocus = -1;
        divCreate = document.createElement('div');
        ulCreate = document.createElement('ul');

        divCreate.appendChild(ulCreate);

        ulCreate.setAttribute('id', searchInput.id + 'autocomplete-list');
        ulCreate.setAttribute('role', 'listbox');
        divCreate.setAttribute('class', 'search-form__dropdown');
        searchInput.parentNode.parentNode.appendChild(divCreate);

        searchForm.classList.add('search-form--has-dropdown');

        for (i = 0; i < items.length; i++) {
            if (items[i].substr(0, fieldVal.length).toUpperCase() == fieldVal.toUpperCase()) {
                listElement = document.createElement('li');
                listButton = document.createElement('button');
                listButton.setAttribute('type', 'button');
                listElement.setAttribute('role', 'option');
                listElement.classList.add('search-form__dropdown__item');
                listElement.setAttribute('id', 'search-form__dropdown__item_'+i);
                listElement.innerHTML = '<span>' + items[i].substr(0, fieldVal.length) + '</span>';
                listElement.innerHTML += items[i].substr(fieldVal.length);
                listElement.setAttribute('data-value', items[i]);
                listElement.setAttribute('aria-setsize', items.length);
                listElement.setAttribute('aria-posinset', i+1);
                listElement.setAttribute('tabindex', "-1");
                // b.innerHTML += "<input type='hidden' value='" + items[i] + "'>";
                listElement.addEventListener('click', function (e) {
                    console.log('click', e.target);
                    searchInput.value = e.target.dataset.value;
                    searchButton.click();
                    // closeAllLists(e.target);
                });
                searchInput.setAttribute('aria-expanded', 'true');
                ulCreate.appendChild(listElement);
            }
        }
    };

    const checkInput = (e) => {
        let fieldVal = e.target.value;

        closeAllLists();

        if (!fieldVal) {
            return false;
        }

        getDataFromApi(fieldVal);
    };

    searchInput.addEventListener(
        'input',
        debounce((e) => checkInput(e))
    );

    searchInput.addEventListener('keydown', function (e) {
        let autocompleteList: any = document.getElementById(this.id + 'autocomplete-list') as any;
        if (autocompleteList) {
            autocompleteList = autocompleteList.getElementsByTagName('li');
        } 

        const key = e.key || e.keyCode;

        if (key == 40 || key == 'ArrowDown') {
            //down
            currentFocus++;
            addActive(autocompleteList);
        } else if (key == 38 || key == 'ArrowUp') {
            //up
            currentFocus--;
            addActive(autocompleteList);
        } else if (key == 13 || key == 'Enter') {
            //enter key
            if (currentFocus > -1) {
                e.preventDefault();
                if (autocompleteList) autocompleteList[currentFocus].click();
            }
        } else if (key === 'Escape' || key === 'Esc' || key === 27) {
            closeAllLists(e.target);
        }

        console.log(currentFocus);
    });

    function addActive(autocompleteList) {
        if (!autocompleteList) return false;
        removeActive(autocompleteList);
        if (currentFocus >= autocompleteList.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = autocompleteList.length - 1;
        searchInput.setAttribute("aria-activedescendant", 'search-form__dropdown__item_' + currentFocus);
        console.log(autocompleteList[currentFocus]);

        autocompleteList[currentFocus].classList.add('autocomplete-active');
        autocompleteList[currentFocus].setAttribute('aria-selected', true);
        // autocompleteList[currentFocus].focus();
    }

    function removeActive(autocompleteList) {
        for (var i = 0; i < autocompleteList.length; i++) {
            autocompleteList[i].classList.remove('autocomplete-active');
            autocompleteList[i].removeAttribute('aria-selected', true);
        }
    }

    function closeAllLists(elmnt?: EventTarget) {
        searchForm.classList.remove('search-form--has-dropdown');
        var autocompleteList = document.getElementsByClassName('search-form__dropdown');
        for (var i = 0; i < autocompleteList.length; i++) {
            if (elmnt != autocompleteList[i] && elmnt != searchInput) {
                autocompleteList[i].parentNode.removeChild(autocompleteList[i]);
            }
        }
        searchInput.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (e) {
        closeAllLists(e.target);
    });
}

autocomplete(document.getElementById('searchPageSearch') as HTMLInputElement);
autocomplete(document.getElementById('headerSearchForm') as HTMLInputElement);
